import Api from '../../../helpers/Api';

export const REQUEST_NEWS_ARCHIVE = 'REQUEST_NEWS_ARCHIVE';
export const RECEIVE_NEWS_ARCHIVE = 'RECEIVE_NEWS_ARCHIVE';
export const FAIL_NEWS_ARCHIVE = 'FAIL_NEWS_ARCHIVE';

export const getNewsArchivePage = (page, category = 'tudo') => async (dispatch, getState) => {
    const key = `${category}:${page}`;
    const existing = getState().news.archivePages[key];

    if (existing && !existing.error) return;

    dispatch({ type: REQUEST_NEWS_ARCHIVE, key });

    try {
        const suffix = category === 'tudo' ? '' : `/${encodeURIComponent(category)}`;
        const result = await Api.progressGet(dispatch, `api/v1/news/getNewsPage/${page}${suffix}`);

        if (result.status !== 'success' && result.status !== 404) throw new Error(result.message || 'Unable to load news');

        dispatch({
            type: RECEIVE_NEWS_ARCHIVE,
            key,
            data: { items: result.data || [], hasNext: !!result.hasNext, notFound: result.status === 404 },
        });
    } catch (error) {
        dispatch({ type: FAIL_NEWS_ARCHIVE, key });

        throw error;
    }
};
